module.exports = __webpack_public_path__ + "img/27.15c965ba.png";